import React from "react";
import ReactSelect from "react-select";
import PropTypes from "prop-types";
import theme from "../theme";

const customStyles = {
  control: provided => ({
    ...provided,
    border: "solid 1px #ccc",
    padding: "1px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  })
};

export const Select = props => {
  return (
    <ReactSelect
      styles={customStyles}
      // getOptionLabel={option => option && option.name}
      // getOptionValue={option => option && option.id}
      {...props}
      theme={prevTheme => ({
        ...prevTheme,
        colors: {
          ...prevTheme.colors,
          primary: theme.palette.PRIMARY
        }
      })}
    />
  );
};

Select.propTypes = {
  className: PropTypes.string
};

Select.defaultProps = {
  className: ""
};
